import VueYoutube from 'vue-youtube'

export class PortableTextPlugin {
  static install(Vue, _options) {
    Vue.use(VueYoutube)
  }
}
